/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IndicatorsAliases {
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  AUTOCOMPLETE_TARGET = 'autocomplete-target',
  AVATAR_0 = 'avatar-0',
  CARD_INDICATOR = 'card-indicator',
  CHECKBOX_0 = 'checkbox-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_INDICATORS = 'deck-indicators',
  FETCH_INDICATORS = 'fetch-indicators',
  FETCH_LOCATOR = 'fetch-locator',
  FETCH_TARGET = 'fetch-target',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_PROVIDER = 'field-provider',
  FIELD_TARGET = 'field-target',
  FILTER_INDICATORS = 'filter-indicators',
  FILTERED_LIST_0 = 'filtered-list-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  MAPPER_AUTOCOMPLETE_TARGET = 'mapper-autocomplete-target',
  PANEL_INDICATORS = 'panel-indicators',
  TEXT_0 = 'text-0',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
  TEXT_AUTOCOMPLETE_TARGET = 'text-autocomplete-target',
}
export { IndicatorsAliases };
